const slugify = require('slugify');

export function createUrlString(input) {
  return slugify(input, { lower: true });
}

export function capitalizeWords(inputString) {
  if (!inputString) {
    return ""
  }
  let words = inputString.split(' ');

  let capitalizedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  let resultString = capitalizedWords.join(' ');

  return resultString;
}

export const translateHead = (key, language, locales, params = {}) => {
  const dataEdges = locales?.edges;

  const translationNode =
    dataEdges?.find((edge) => edge.node.language === language) ||
    dataEdges?.find((edge) => edge.node.language === 'en')?.node;

  if (!translationNode) {
    return key;
  }

  const jsonData = JSON.parse(translationNode.node.data);
  const nestedKeys = key.split('.');
  let currentObject = jsonData;

  for (const nestedKey of nestedKeys) {
    currentObject = currentObject[nestedKey];

    if (!currentObject) {
      return key;
    }
  }

  const translation = currentObject || key;

  const replacedTranslation = translation.replace(/%{(\w+)}/g, (_, param) => {
    return params[param] || '';
  });
  
  return replacedTranslation;
};
